import { axios } from '~/common/utils/request'

export const state = {
  warehouseList: [],
  sectionList: [],
  carrierList: [],
  packingTypeList: [],
  insidePackingList: [],
  shippingMethodList: [],
  tariffTypeList: [],
  tariffFilingList: []
}

export const mutations = {
  setWarehouseList(state, data) {
    state.warehouseList = data
  },
  setSectionList(state, data) {
    state.sectionList = data
  },
  setCarrierList(state, data) {
    state.carrierList = data
  },
  setPackingTypeList(state, data) {
    state.packingTypeList = data
  },
  setInsidePackingList(state, data) {
    state.insidePackingList = data
  },
  setShippingMethodList(state, data) {
    state.shippingMethodList = data
  },
  setTariffTypeList(state, data) {
    state.tariffTypeList = data
  },
  setTariffFilingList(state, data) {
    state.tariffFilingList = data
  }
}

export const actions = {
  // 仓库
  async getWarehouseList({state, commit}, isForce = false) {
    if(state.warehouseList.length && !isForce) {
      return state.warehouseList
    } else {
      const {code, data: { list }} = await axios({
        url: `rest/portal/logistics/v3/warehouse/list`,
        method: 'post',
        data: {
          current: 1,
          page_size: 1000
        }
      })
      if(code != 200) return []
      commit('setWarehouseList', list)
      return list
    }
  },
  // 库区
  async getSectionList({state, commit}, isForce = false) {
    if(state.sectionList.length && !isForce) {
      return state.sectionList
    } else {
      const {code, data: { list }} = await axios({
        url: `rest/portal/logistics/v3/section/list`,
        method: 'post',
        data: {
          current: 1,
          page_size: 1000
        }
      })
      if(code != 200) return []
      commit('setSectionList', list)
      return list
    }
  },
  // 承运商
  async getCarrierList({state, commit}) {
    if(state.carrierList.length) {
      return state.carrierList
    } else {
      const {code, data: { list }} = await axios({
        url: `rest/portal/logistics/v3/carrier/list`,
        method: 'post',
        data: {
          order_by: "list_order ascending"
        }
      })
      if(code != 200) return []
      commit('setCarrierList', list)
      return list
    }
  },
  // 箱型
  async getPackingTypeList({state, commit}) {
    if(state.packingTypeList.length) {
      return state.packingTypeList
    } else {
      const {code, data} = await axios({
        url: `rest/erp/logistics/v3/packing_type/all`,
        method: 'get'
      })
      if(code != 200) return []
      commit('setPackingTypeList', data)
      return data
    }
  },
  // 包装
  async getInsidePackingList({state, commit}) {
    if(state.insidePackingList.length) {
      return state.insidePackingList
    } else {
      const {code, data} = await axios({
        url: `rest/erp/logistics/v3/packing_item/type/all`,
        method: 'get'
      })
      if(code != 200) return []
      commit('setInsidePackingList', data)
      return data
    }
  },
  // 货运方式
  async getShippingMethodList({state, commit}) {
    if(state.shippingMethodList.length) {
      return state.shippingMethodList
    } else {
      const {code, data: { list }} = await axios({
        url: `rest/portal/logistics/v3/shipping/method/list`,
        method: 'post'
      })
      if(code != 200) return []
      commit('setShippingMethodList', list)
      return list
    }
  },
  // 关单类型
  async getTariffTypeList({state, commit}) {
    if(state.tariffTypeList.length) {
      return state.tariffTypeList
    } else {
      const {code, data} = await axios({
        url: `rest/erp/logistics/v3/tariff/bill_nature/list`,
        method: 'get'
      })
      if(code != 200) return []
      commit('setTariffTypeList', data)
      return data
    }
  },
  // 报关方式
  async getTariffFilingList({state, commit}) {
    if(state.tariffFilingList.length) {
      return state.tariffFilingList
    } else {
      const {code, data} = await axios({
        url: `rest/erp/logistics/v3/tariff/filing/type`,
        method: 'get'
      })
      if(code != 200) return []
      commit('setTariffFilingList', data)
      return data
    }
  }
}

export default {
  namespaced: true,
	state,
	mutations,
  actions
}